import React from 'react';
import { Container } from 'react-bootstrap';
import loader from './../assets/globe.gif'

export default function GlobeLoader() {
  return (
    <Container style={{height: '100vh'}} className="d-flex justify-content-center align-items-center">
        <img style={{height: '200px'}} src={loader} alt="loader" />
    </Container>
  )
}